export class LanguageLevelMapper {
  private static levelMap: Record<string, string> = {
    '1': 'A1',
    '2': 'A2',
    '3': 'B1',
    '4': 'B2',
    '5': 'C1',
    '6': 'C2',
    '7': 'Muttersprache',
  }

  public static mapLevel(levelCode: string | number | null): string | null {
    if (!levelCode) return null
    return this.levelMap[levelCode] || null
  }
}
